<!-- @format -->

@if (dropdownValues()) {
	@if (selectedValue()) {
		<select
			id="sort-list"
			class="sort-select hmf-py-lg-xxs hmf-pl-lg-0 hmf-pr-lg-m no-outline hmf-body-m hmf-pl-xxs hmf-pr-xs hmf-py-xs"
			title="Select sort option"
			[value]="selectedValue().value"
			[disabled]="isDisabled()"
			(change)="selectValue($event)"
			(keydown.tab)="onTabKeyDown()">
			@for (option of dropdownValues(); track option.value) {
				<option
					[value]="option.value"
					[attr.selected]="option.value === selectedValue()?.value || null">
					{{ option.label }}
				</option>
			}
		</select>
	}

	<homefield-icon
		class="sort-select-arrow hmf-position-absolute"
		name="chevron-down-outline"
		width="16px"
		height="16px">
	</homefield-icon>
}
